// ==========================================
// 🏴 阵营专属事件池 (根据开局选择动态加载)
// ==========================================
export const factionEvents = {
  // 1. 激进大模型 (GPT) 专属：主打算力焦虑、暴力替代、高风险
  gpt: [
    {
      id: "f_gpt_1",
      type: "normal",
      title: "🤖 【激进派】OpenAI 接口突然熔断",
      description: "你们完全依赖外部接口，结果今天对方封禁了国内IP，全公司的AI服务瞬间变成了智障。",
      condition: (state) => state.round >= 3,
      choices: [
        { text: "花高价买海外代理节点续命", effect: { money: -15000, stability: +15, san: -10 } },
        { text: "连夜切回老旧的备用本地模型", effect: { tech: -20, stability: -10, self: -10 } }
      ]
    }
  ],

  // 2. 保守私有化 (Safe) 专属：主打数据安全、内耗、效率低下
  safe: [
    {
      id: "f_safe_1",
      type: "normal",
      title: "🛡️ 【保守派】私有化部署的智商瓶颈",
      description: "为了绝对安全，你们部署了只有7B参数的本地小模型。业务方抱怨它连个JSON都格式化不对。",
      condition: (state) => state.round >= 2,
      choices: [
        { text: "嘴硬！强调数据安全大于一切！", effect: { tech: -10, stability: +15, self: +10 } },
        { text: "偷偷把复杂请求转发给外网大模型", effect: { tech: +20, stability: -15, san: -15 } }
      ]
    }
  ],

  // 3. 开源社区 (Open) 专属：主打百花齐放、技术狂热、但极不稳定
  open: [
    {
      id: "f_open_1",
      type: "normal",
      title: "🌍 【开源派】Llama 新版本开源了！",
      description: "昨晚开源社区发布了极其强大的新模型，你的团队兴奋得睡不着，要求立刻全面接入。",
      condition: (state) => state.round >= 2,
      choices: [
        { text: "立刻抛弃旧架构，拥抱新开源！", effect: { tech: +20, stability: -25, san: -10 } },
        { text: "先观望，等别人踩完坑再说", effect: { tech: -10, stability: +10, san: +5 } }
      ]
    }
  ],

  // 4. 资本概念 (Capital) 专属：主打写PPT、圈钱、不干实事
  capital: [
    {
      id: "f_cap_1",
      type: "normal",
      title: "💰 【资本派】投资人的灵魂拷问",
      description: "投资人来视察，发现你们所谓的“自主研发AGI”其实只是套了个漂亮的前端壳调用 API。",
      condition: (state) => state.round >= 4,
      choices: [
        { text: "狂写 50 页 PPT 忽悠过去", effect: { money: +20000, self: +15, san: -20, tech: -15 } },
        { text: "花钱雇水军在网上发软文造势", effect: { money: -10000, industry: +15, stability: +10 } }
      ]
    }
  ]
};